function NewsPaperAddValidation(Values) {
  let error = {};
  if (Values.newspaper_name) {
    error.newspaper_name = Values.newspaper_name;
  } else {
    error.newspaper_name = "";
  }

  if (Values.state_id) {
    error.state_id = Values.state_id;
  } else {
    error.state_id = "";
  }

  if (Values.city_id) {
    error.city_id = Values.city_id;
  } else {
    error.city_id = "";
  }

  if (Values.mode_of_given) {
    error.mode_of_given = Values.mode_of_given;
  } else {
    error.mode_of_given = "";
  }

  if (Values.news_category) {
    error.news_category = Values.news_category;
  } else {
    error.news_category = "";
  }

  if (Values.words) {
    error.words = Values.words;
  } else {
    error.words = "";
  }
  if (Values.lines) {
    error.lines = Values.lines;
  } else {
    error.lines = "";
  }
  if (Values.ads_formate) {
    error.ads_formate = Values.ads_formate;
  } else {
    error.ads_formate = "";
  }

  return error;
}

export default NewsPaperAddValidation;
